import { toEDNString } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { ConnectorUrlConfig } from "../types/pullConnector";

export const getConnectors: (config: {
  appId: string;
}) => Promise<any> = async ({ appId }) => {
  const ednString = toEDNString({
    map: [["app-id", appId]],
  });
  const query = `
        (datastore Qo.Public.Api.Fivetran "omega/query-omega/public/api/fivetran")
        (Qo.Public.Api.Fivetran/get-connectors ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const getConnectorConfigUrl: (config: {
  connectorId: string;
}) => Promise<ConnectorUrlConfig> = async ({ connectorId }) => {
  const ednString = toEDNString({
    map: [["connection-id", connectorId]],
  });
  const query = `
        (datastore Qo.Public.Api.Fivetran "omega/query-omega/public/api/fivetran")
        (Qo.Public.Api.Fivetran/connector-config-url ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const deleteConnector: (config: {
  connectorId: string;
  appId: string;
}) => Promise<any> = async ({ connectorId, appId }) => {
  const ednString = toEDNString({
    map: [
      ["connection-id", connectorId],
      ["app-id", appId],
    ],
  });
  const query = `
        (datastore Qo.Public.Api.Fivetran "omega/query-omega/public/api/fivetran")
        (Qo.Public.Api.Fivetran/delete-connector ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
